import { render, staticRenderFns } from "./blog-preview-badge.vue?vue&type=template&id=d187ac44"
import script from "./blog-preview-badge.vue?vue&type=script&lang=js"
export * from "./blog-preview-badge.vue?vue&type=script&lang=js"
import style0 from "./blog-preview-badge.vue?vue&type=style&index=0&id=d187ac44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports